import React from 'react';
import './Utils.css';


export class Input extends React.Component {


	static INPUT_ID = 0


	constructor(props) {
		super(props)
		//this.inputID = (this.props.id ? this.props.id : ++Input.INPUT_ID)
		this.inputID = ++Input.INPUT_ID
		let initText = this.format(this.props.text)
		this.state = {
			editMode: (this.props.startInEditMode ? true : false),
			text: initText
		}
		this.originalText = initText
		this.sizeFactor = (this.props.sizeFactor !== undefined ? this.props.sizeFactor : 1)
	}


	componentDidMount() {
		if (this.props.startInEditMode) {
			let elem = document.getElementById(this.inputID)
			if (elem !== undefined) {
				elem.select()
				elem.focus()
			}
		}
	}


	UNSAFE_componentWillReceiveProps(nextProps) {
		let text = this.format(nextProps.text)
		if (!this.state.editMode) {
			this.setState({text: text})
		}
		this.originalText = text
	}


	format(text) {
		if (text === undefined || text === null)
			return ""
		return text
	}


	onChange(event) {
		this.setState({text: event.target.value})
		this.propagateEvent(event)
	}


	onKeyUp(event) {
		if (event.key === "Tab") {
			this.propagateEvent(event)
		}
		else if (event.key === "Enter") {
			this.onBlur(event)
		}
		else if (event.key === "Escape") {
			this.setState({editMode: false, text: this.originalText})
			event.target.value = this.originalText
			event.target.setSelectionRange(0, 0)
			this.propagateEvent(event)
		}
	}


	onClick(event) {
		if (this.props.allowEditOnClick) {
			if (!this.props.readOnly) {
				this.setState({editMode: true})
				event.target.select()
				this.propagateEvent(event)
			} 
		}
	}


	onDoubleClick(event) {
		if (!this.props.preventEditOnDoubleClick) {
			if (!this.props.readOnly) {
				this.setState({editMode: true})
				event.target.select()
				this.propagateEvent(event)
			} 
		}
	}


	onBlur(event) {
		if (!this.props.readOnly) {
			if (this.state.editMode) {
				this.originalText = event.target.value
				this.setState({editMode: false})
				this.props.store(event.target.value)
				this.propagateEvent(event)
			}
		}
	}


	propagateEvent(event) {
		if (this.props.eventHandler) {
			this.props.eventHandler.onInputEvent(event, this.props.data, this.props.kind)
		}
	}


	getClassName() {
		let className = this.props.className
		if (this.props.readOnly)
			className += "_ReadOnly"
		else if (this.state.editMode)
			className += "_EditMode"
		else
			className += "_Normal"
		return className
	}

	
	render() {
		if (this.state.text === null) 	
			return null
		let pl = 30
		return (
			<input 
				id = {this.inputID}
				readOnly = {this.props.readOnly || !this.state.editMode}
				className = {this.getClassName()}
				type = "text"
				value = {this.state.text}
				style = {{width: pl + "px", color: this.props.color}}
				onChange = {(event) => this.onChange(event)}
				onKeyUp = {(event) => this.onKeyUp(event)}
				onBlur = {(event) => this.onBlur(event)}
				onClick = {(event) => this.onClick(event)}
				onDoubleClick = {(event) => this.onDoubleClick(event)}
				/>
		)
	}
	
	
}